import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {IOrder, IOrdersStore} from '../../mobx-store/storeInterfaces/ordersStoreInterface';
import styles from './orders.module.sass';
import {Collapse, CardBody, Card, Button, ModalBody, Modal} from 'reactstrap';
import {CustomDropDown, ISelectItemData} from "../../components/DropDown";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface IProps {
    ordersStore: IOrdersStore;
}

interface IOrdersState {
    value: string;
}

@inject('ordersStore')
@observer
class Orders extends Component<IProps, IOrdersState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: ''
        };
    }

    onTextChange = (e: any) => this.setState({value: e.target.value}, () => this.props.ordersStore.filterOrders(this.state.value));

    componentDidMount(): void {
        this.props.ordersStore.getOrders();
    }

    render() {
        const {loaded, filteredOrders, updateOrderStatus} = this.props.ordersStore;
        return loaded && (
            <>
                <p className={styles.content}>
                    Manage Orders
                </p>
                <input className={styles.search} onChange={this.onTextChange}
                       value={this.state.value} placeholder='Search by name or phone number...'/>
                <div className={styles.orderWrapper}>
                    {filteredOrders.map(o => <Order updateOrderStatus={updateOrderStatus} order={o} key={o.orderId}/>)}
                </div>
            </>
        );
    }
}

export default Orders;

const selectStatuses: ISelectItemData[] = [
    {
        label: 'Pending',
        value: 'PENDING'
    },
    {
        label: 'Delivering',
        value: 'DELIVERING'
    },
    {
        label: 'Postponed',
        value: 'POSTPONED'
    },
    {
        label: 'Delivered',
        value: 'DELIVERED'
    },
    {
        label: 'Cancelled',
        value: 'CANCELLED'
    },
];

interface IState {
    collapse: boolean;
    isPreviewOpen: boolean;
}

class Order extends Component<{ order: IOrder, updateOrderStatus(orderId: string, status: string): Promise<any> }, IState> {
    constructor(props: {
        order: IOrder, updateOrderStatus(orderId: string, status: string): Promise<any>;
    }) {
        super(props);
        this.state = {collapse: false, isPreviewOpen: false};
    }

    printDocument() {
        const input = document.getElementById('divToPrint');
        html2canvas(input as any)
            .then((canvas: any) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'JPEG', 0, 0);
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            })
        ;
    }

    toggle = () => this.setState(prevStat => ({collapse: !prevStat.collapse}));
    togglePreview = () => this.setState(prevStat => ({isPreviewOpen: !prevStat.isPreviewOpen}));
    print = () => {
        const content = document.getElementById('divToPrint');
        const pri = (document.getElementById('ifmcontentstoprint') as any).contentWindow;
        pri.document.open();
        pri.document.write((content as any).innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    };
    onDDChange = (value: ISelectItemData) => this.props.updateOrderStatus(this.props.order.orderId, value.value);

    render() {
        const {order} = this.props;
        const status = selectStatuses.filter(stat => stat.value === order.orderStatus)[0];
        return order && (
            <div className={styles.wrapper}>
                <div className={styles.fp}>
                    {order.user && <div className={styles.userWrapper}>
                        <p className={styles.userName}>{order.user.name}</p>
                        <p className={styles.userAddress}>{order.user.address}</p>
                        <p className={styles.userPhone}>{order.user.phoneNumber}</p>
                    </div>}
                    <p className={styles.status}>
                        <CustomDropDown options={selectStatuses} start={status} onChange={this.onDDChange}
                                        shadow={false}/>
                    </p>
                    <p className={styles.totalPrice}>Total Price: {order.totalPrice}</p>
                    <p className={styles.totalPrice}>Order Id: {order.orderId.substr(order.orderId.length - 5)}</p>
                    <Button
                        variant='contained'
                        size='small'
                        color='primary'
                        style={{fontSize: '1.5rem', margin: '0 2rem'}}
                        onClick={this.toggle}>
                        Show Details
                    </Button>
                    <Button
                        variant='contained'
                        size='small'
                        color='primary'
                        style={{fontSize: '1.5rem'}}
                        onClick={this.togglePreview}>
                        Preview
                    </Button>
                </div>
                <Collapse isOpen={this.state.collapse}>
                    <Card style={{border: 0}}>
                        <CardBody style={{padding: 0}}>
                            <div className={styles.sp}>
                                <p className={styles.itemsText}>Order Items</p>
                                <div className={styles.items}>
                                    {order.items.map(item => {
                                        return item ? (<div key={item.itemId} className={styles.item}>
                                            <div className={styles.itemWrapper}>
                                                <img src={item.item.image} className={styles.itemImg}/>
                                                <div className={styles.itemData}>
                                                    <p className={styles.itemName}>{item.item.name}</p>
                                                    <p className={styles.itemPrice}>Price: {item.item.price}</p>
                                                    <p className={styles.itemQuantity}>Quantity: {item.quantity}</p>
                                                    <p className={styles.discount}>Discount: {item.item.discount}%</p>
                                                </div>
                                            </div>
                                            {item.note && <p className={styles.itemNote}>Note: <br/> {item.note}</p>}
                                        </div>) : '';
                                    })}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
                <Modal size='lg' toggle={this.togglePreview} isOpen={this.state.isPreviewOpen}>
                    <ModalBody style={{padding: 0}}>
                        <iframe id="ifmcontentstoprint" style={{
                            height: '0px',
                            width: '0px',
                            position: 'absolute'
                        }}/>
                        <div style={{display: 'flex', margin: '2rem 1rem'}}>
                            <Button
                                variant='contained'
                                size='small'
                                color='secondary'
                                style={{fontSize: '1.5rem'}}
                                onClick={this.printDocument}>
                                Download as PDF
                            </Button>
                            <Button
                                variant='contained'
                                size='small'
                                color='secondary'
                                style={{fontSize: '1.5rem', margin: '0 2rem'}}
                                onClick={this.print}>
                                Print
                            </Button>
                        </div>
                        <div id="divToPrint" className={styles.previewWrapper}>
                            <div className={styles.fp}>
                                <div className={styles.userWrapper}>
                                    <p className={styles.userName}>Username: {order.user.name}</p>
                                    <p className={styles.userAddress}>User address: {order.user.address}</p>
                                    <p className={styles.userPhone}>User phone: {order.user.phoneNumber}</p>
                                </div>
                                <p className={styles.totalPrice}>Total Price: {order.totalPrice}</p>
                            </div>
                            <div className={styles.sp}>
                                <p className={styles.itemsText}>Order Items</p>
                                <div className={styles.items}>
                                    {order.items.map(item => {
                                        return item ? (<div key={item.itemId} className={styles.item}>
                                            <div className={styles.itemWrapper}>
                                                <img src={item.item.image} className={styles.itemImg}/>
                                                <div className={styles.itemData}>
                                                    <p className={styles.itemName}>{item.item.name}</p>
                                                    <p className={styles.itemPrice}>Price: {item.item.price}</p>
                                                    <p className={styles.itemQuantity}>Quantity: {item.quantity}</p>
                                                    <p className={styles.discount}>Discount: {item.item.discount}%</p>
                                                </div>
                                            </div>
                                            {item.note && <p className={styles.itemNote}>Note: <br/> {item.note}</p>}
                                        </div>) : '';
                                    })}
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}